import { PropsWithChildren } from "react";
import * as CSS from "csstype";

import {
  Checkbox,
  HStack,
  Stack,
  Text,
  StackDirection,
  useColorModeValue,
  Box,
} from "@chakra-ui/react";

import { useRequestParams } from "contexts/RequestParamsProvider";
import { DesktopOnly, MobileOnly } from "components/BreakpointVisibility";
import SortTermsSelect, { SortSelectProps } from "components/SortTermsSelect";
import { detailsBodyPadding, mobileStyleBreakpoint } from "util/styleHelpers";
import { Filter, FiltersButtonWithModal } from "components/Filters";

const stackDirection = mobileStyleBreakpoint<StackDirection>(
  "column",
  "row"
) as StackDirection;
const stackAlign = mobileStyleBreakpoint<CSS.Property.AlignContent>(
  "flex-start",
  "flex-end"
);

export const FilterSectionStickyHeader = ({ children }: PropsWithChildren) => {
  const bg = useColorModeValue("white", "grey.700");
  return (
    <Stack
      position="sticky"
      top={0}
      zIndex={1}
      spacing={4}
      px={detailsBodyPadding}
      py={4}
      align={stackAlign}
      direction={stackDirection}
      bg={bg}
    >
      {children}
    </Stack>
  );
};

export const detailsTabFilterCategories = [
  {
    placeholder: "Ship From",
    filterKey: "shipFrom",
  },
  {
    placeholder: "Ship To",
    filterKey: "shipTo",
  },
  {
    placeholder: "Mode",
    filterKey: "mode",
  },
];

const ToggleCheckbox = ({
  label,
  selected,
  onChange = () => {
    return;
  },
}: ToggleOption & {
  onChange?(value: boolean): void;
  selected?: boolean;
}) => (
  <HStack spacing={2}>
    <Checkbox
      isChecked={selected}
      onChange={(event) => onChange(event.target.checked)}
    />
    <Text textStyle="body2" whiteSpace="nowrap">
      {label}
    </Text>
  </HStack>
);

const ContractDetailsFiltersSection = ({
  toggles = [],
  sortOptions = [],
  filterDefinitions,
}: Pick<SortSelectProps, "sortOptions"> & {
  toggles?: ToggleOption[];
  filterDefinitions: Filter[];
}): React.ReactElement => {
  const { activeSort, onChangeSort, onChangeToggle } = useRequestParams();

  return (
    <>
      <DesktopOnly>
        <HStack spacing={2} justifyContent="flex-end">
          <HStack spacing={2} flex={2} w="100%">
            {filterDefinitions.map(({ key, component: Component }) => (
              <Component key={key} variant="button" />
            ))}
          </HStack>
          {toggles.map((toggle) => (
            <ToggleCheckbox
              key={toggle.label}
              {...toggle}
              onChange={(selected) =>
                onChangeToggle(toggle.filterKey, selected)
              }
            />
          ))}
        </HStack>
      </DesktopOnly>
      <MobileOnly>
        <HStack>
          <FiltersButtonWithModal filters={filterDefinitions} />
          <Box>
            <SortTermsSelect
              sortOptions={sortOptions}
              selectedSortKey={activeSort?.key}
              selectedDirection={activeSort?.direction}
              onChange={onChangeSort}
            />
          </Box>
        </HStack>
      </MobileOnly>
    </>
  );
};

export default ContractDetailsFiltersSection;
